// Zamienia tytuł wpisu na fragment adresu URL (slug), np.
// "Jak zoptymalizować Excel?" -> "jak-zoptymalizowac-excel"
// Obcina zbyt długie tytuły do rozsądnej długości, żeby link nie był
// nieporęcznie długi, ale zawsze kończy na granicy słowa.

const POLISH_MAP = {
  ą: "a", ć: "c", ę: "e", ł: "l", ń: "n", ó: "o", ś: "s", ź: "z", ż: "z",
  Ą: "a", Ć: "c", Ę: "e", Ł: "l", Ń: "n", Ó: "o", Ś: "s", Ź: "z", Ż: "z",
};

export function slugify(text, maxLength = 60) {
  if (!text) return "wpis";

  const replaced = text
    .split("")
    .map((ch) => POLISH_MAP[ch] || ch)
    .join("");

  let result = replaced
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

  if (result.length > maxLength) {
    const truncated = result.slice(0, maxLength);
    const lastDash = truncated.lastIndexOf("-");
    result = lastDash > 20 ? truncated.slice(0, lastDash) : truncated;
  }

  return result || "wpis";
}

// Formatuje datę wpisu (np. "2026-09-23") na czytelną polską formę,
// np. "23 września 2026". Jeśli data jest nieprawidłowa, zwraca ją bez zmian.
export function formatPostDate(dateStr) {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return dateStr;
  return d.toLocaleDateString("pl-PL", { day: "numeric", month: "long", year: "numeric" });
}
